import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from '@wegroup/design-system';
import React from 'react';
import useTempLanguage from '../../../../../hooks/useTempLanguage';
import { useLocale } from '../../../../../../../../i18n';
import { useFlowsRouteParams } from '../../../../../hooks/useFlowsRouteParams';
import useSessionId from '../../../../../hooks/useSessionId';
import { useFlowsSession } from '../../../../../api/getFlowsSessionById';
import useFlowsLanguageOptions from '../../../../../hooks/useFlowsLanguageOptions';

const FlowLanguageChangeMenu: React.FC = () => {
  const { sessionId, flowId } = useFlowsRouteParams();
  const qSessionId = useSessionId();
  const { data: session } = useFlowsSession(sessionId || qSessionId);

  const sessionFlowId = session?.flow_id || flowId || '';

  const { setTempLanguage } = useTempLanguage();
  const { userLang } = useLocale();
  const options = useFlowsLanguageOptions(sessionFlowId);

  const handleOnMenuItemClick = (lang: string) => {
    setTempLanguage(lang);
  };

  if (options.length === 0) return null;

  return (
    <Menu isLazy>
      <MenuButton
        as={Button}
        w="10"
        h="10"
        bg="secondary.600"
        color="secondary.300"
        p="0"
        _hover={{ bg: 'secondary.500' }}
      >
        {userLang.toUpperCase()}
      </MenuButton>
      <MenuList zIndex="2">
        {options.map(({ label, value }) => (
          <MenuItem key={value} onClick={() => handleOnMenuItemClick(value)}>
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default FlowLanguageChangeMenu;
